import { useMemo } from "react";
import { FieldValues } from "react-hook-form";

import { SelectProps as SelectFieldProps } from "components/ui/select/Select";
import SkeletonText from "components/ui/skeleton/SkeletonText";
import { useBidWorkflow } from "lib/hooks/api/bid/bids/useBidWorkflow";
import { ExtendedStageOption, processTransitions } from "../../../shared/stage/utils";
import { StageSelect } from "./StageSelect";

type BidStageSelectProps<TFieldValues extends FieldValues = FieldValues> = Omit<
  SelectFieldProps<TFieldValues>,
  "children"
> & { truncate?: boolean };

/* New BidStageSelect component */
export function BidStageSelect<TFieldValues extends FieldValues = FieldValues>(
  props: BidStageSelectProps<TFieldValues>,
) {
  const { data, isLoading } = useBidWorkflow();

  const flatOptions: ExtendedStageOption[] = useMemo(() => {
    if (!data?.transitions) return [];
    const grouped = processTransitions(data.transitions);
    return grouped.flatMap((group) => group.options);
  }, [data]);

  if (isLoading) {
    return <SkeletonText width={"200px"} />;
  }

  return <StageSelect {...props} options={flatOptions} />;
}
